import apiClient from '../../../../shared/services/apiClient';
import { unwrapEnvelopeData, unwrapEnvelopePaged } from '../../../../shared/services/apiHelpers';

const SESSION_KEY = 'nf_mp_session';

function getOrCreateSessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = crypto.randomUUID?.() || `mp-${Date.now()}`;
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return `mp-${Date.now()}`;
  }
}

export function marketplaceHeaders() {
  return { 'X-Mp-Session': getOrCreateSessionId() };
}

function normalizeFeaturedPayload(data) {
  const featured = data?.featured ?? data?.Featured ?? [];
  const recent = data?.recent ?? data?.Recent ?? [];
  const categories = data?.categories ?? data?.Categories ?? [];
  return {
    featured: Array.isArray(featured) ? featured : [],
    recent: Array.isArray(recent) ? recent : [],
    categories: Array.isArray(categories) ? categories : [],
  };
}

const MarketplaceService = {
  marketplaceHeaders,

  getFeatured: (limit = 8) =>
    apiClient.get('/marketplace/featured', { params: { limit }, headers: marketplaceHeaders() })
      .then((r) => normalizeFeaturedPayload(unwrapEnvelopeData(r))),

  searchProperties: (params) =>
    apiClient.get('/marketplace/properties', { params, headers: marketplaceHeaders() })
      .then((r) => unwrapEnvelopePaged(r, params.page || 1, params.pageSize || 20)),

  getPropertyBySlug: (slug) =>
    apiClient.get(`/marketplace/properties/${encodeURIComponent(slug)}`, { headers: marketplaceHeaders() })
      .then((r) => unwrapEnvelopeData(r)),

  recordView: (slug, eventType = 'Impression') =>
    apiClient.post(
      `/marketplace/properties/${encodeURIComponent(slug)}/view`,
      { eventType },
      { headers: marketplaceHeaders() },
    ),

  getCategories: () =>
    apiClient.get('/marketplace/categories', { headers: marketplaceHeaders() }).then((r) => unwrapEnvelopeData(r)),

  getLocations: (q, limit = 20) =>
    apiClient.get('/marketplace/locations', { params: { q, limit }, headers: marketplaceHeaders() })
      .then((r) => unwrapEnvelopeData(r)),

  submitEnquiry: (slug, body) =>
    apiClient.post(`/marketplace/properties/${encodeURIComponent(slug)}/enquiries`, body, { headers: marketplaceHeaders() })
      .then((r) => unwrapEnvelopeData(r)),

  addFavourite: (slug) =>
    apiClient.post(`/marketplace/properties/${encodeURIComponent(slug)}/favourites`, null, { headers: marketplaceHeaders() })
      .then((r) => unwrapEnvelopeData(r)),

  removeFavourite: (slug) =>
    apiClient.delete(`/marketplace/properties/${encodeURIComponent(slug)}/favourites`, { headers: marketplaceHeaders() }),
};

export default MarketplaceService;
